














import {Component, Vue, Mixins} from "vue-property-decorator";
import { PageVisitSumary, TrackingService } from "../services/tracking.service";
import {Chart,} from 'highcharts-vue';
import {ChartOptions} from 'highcharts';

@Component({
    components: {
        Chart,
    }
})
export default class SiteMetrics extends Vue {
    private service!: TrackingService;
    private summary!: PageVisitSumary;
    private initialized = false;

    private totalPageVisits: number = 0;
    private uniqueVisitors: number = 0;

    private chartOptions: any = {
        title: {
            text: 'Daily Summary'
        },
        xAxis: {
            type: 'datetime'
        },
        credits: {
            enabled: false
        },
        legend: {
            enabled: true,
        },
        series: [],
    }

    private async created() {
        this.service = new TrackingService();
        const res = await this.service.getPageVisitReport();
        if (res.success) {
            this.summary = res.result;
            this.initialized = true;

            this.chartOptions.series.push({
                name: 'Daily Visitors',
                data: this.summary.timeseries.map(x => {
                    return [new Date(x.date).getTime() , x.pageVisits];
                })
            })

            this.chartOptions.series.push({
                name: 'Unique Daily Visitors',
                data: this.summary.timeseries.map(x => {
                    return [new Date(x.date).getTime(), x.distinctVisitors];
                })
            })
        }
    }
}

